import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { ContentSearchResults, ContentSearchModalTitle, Spinner, EmptyState } from 'components';
import { AppLayout, ContentWrap, ContentDirectory } from 'containers';
import { connect, Provider, ReactReduxContext } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { getFavorites } from 'redux/modules/contentLibrary';
import { getBuckets } from 'redux/modules/contentLibraryContent';
import { clearCurrentSearch, searchContent, updateSearchQuery, usePrevSearch } from 'redux/modules/contentSearch';
import { loadOrganizationQueues } from 'redux/modules/queues';
import Typist from 'react-typist';
import _ from 'lodash';
var ContentLibrary = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    searching: state.contentSearch.searching,
    searchQuery: state.contentSearch.searchResults[orgId] && state.contentSearch.searchResults[orgId].currentQuery ? state.contentSearch.searchResults[orgId].currentQuery : '',
    searchResults: state.contentSearch.searchResults[orgId],
    favorites: state.contentLibrary[orgId] && state.contentLibrary[orgId].favorites ? state.contentLibrary[orgId].favorites : [],
    loadingFavorites: state.contentLibrary.loadingFavorites,
    buckets: state.contentLibraryContent.buckets,
    queues: state.queues[orgId] || [],
    categories: state.contentLibraryContent.categories,
    loadingBuckets: state.contentLibraryContent.loadingBuckets
  };
}, {
  getBuckets: getBuckets,
  getFavorites: getFavorites,
  loadOrganizationQueues: loadOrganizationQueues,
  clearCurrentSearch: clearCurrentSearch,
  searchContent: searchContent,
  updateSearchQuery: updateSearchQuery,
  usePrevSearch: usePrevSearch
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ContentLibrary, _Component);

  var _super = _createSuper(ContentLibrary);

  function ContentLibrary(props) {
    var _this;

    _classCallCheck(this, ContentLibrary);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "openSearchModal", function () {
      _this.setState({
        searchModalOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchContent", function (orgId, value) {
      if (!value || !orgId) {
        return false;
      }

      if (value.length < 5) {
        console.log('calling throttled');

        _this.searchContentThrottled(orgId, value);
      } else if (value.length > 4) {
        console.log('calling debounced');

        _this.searchContentDebounced(orgId, value);
      }
    });

    _this.state = {
      searchModalOpen: false,
      searchSuggestionIndex: 0,
      searchSuggestions: _.shuffle(['Real estate', 'Dentistry', 'Technology', 'Food', 'Cleaning', 'Pool', 'Fashion', 'Marketing', 'Travel', 'Cars', 'News', 'Media', 'Art', 'Entertainment', 'Sports', 'Medical', 'Health', 'Beauty', 'Pets']),
      typistRemount: new Date().getTime()
    };
    _this.searchContentDebounced = _.debounce(props.searchContent, 1000);
    _this.searchContentThrottled = _.throttle(props.searchContent, 1000);
    return _this;
  }

  _createClass(ContentLibrary, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.favorites.length) {
        this.props.getFavorites(this.props.organization.id);
      }

      if (!this.props.buckets.length) {
        this.props.getBuckets();
      }

      if (!this.props.queues.length) {
        this.props.loadOrganizationQueues(this.props.organization.id);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isDirectoryPath = this.props.location.pathname.includes('directory');
      var hasFavorites = !!this.props.favorites.length;
      var categorySlug = this.props.params.categorySlug ? this.props.params.categorySlug : hasFavorites ? this.props.favorites[0].slug : null;
      var bucketSlug = this.props.params.bucketSlug ? this.props.params.bucketSlug : null;

      if (bucketSlug && this.props.buckets && this.props.buckets.length) {
        categorySlug = this.props.params.categorySlug ? this.props.params.categorySlug : this.props.buckets.find(function (b) {
          return b.slug === bucketSlug;
        }).Categories[0].slug;
      }

      return this.props.loadingBuckets || !this.props.categories.length || !this.props.favorites.length && this.props.loadingFavorites ? /*#__PURE__*/React.createElement(AppLayout, {
        params: _objectSpread({}, this.props.params),
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: '0 0 0 36px',
          overflow: 'hidden',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "container-fluid",
        style: {
          height: '100%',
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          height: 75,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })))) : /*#__PURE__*/React.createElement(AppLayout, {
        params: _objectSpread({}, this.props.params),
        appLayoutInnerStyle: _objectSpread({
          display: 'flex',
          flex: '1 1 auto',
          overflowY: 'auto',
          overflowX: 'hidden',
          height: '100%'
        }, isDirectoryPath ? {
          paddingLeft: 36
        } : {})
      }, isDirectoryPath ? /*#__PURE__*/React.createElement(ContentDirectory, {
        params: this.props.params,
        openSearchModal: this.openSearchModal
      }) : /*#__PURE__*/React.createElement(ContentWrap, {
        categorySlug: categorySlug,
        bucketSlug: bucketSlug,
        params: this.props.params,
        openSearchModal: this.openSearchModal
      }), /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          actions: [],
          autoScrollBodyContent: true,
          bodyStyle: {
            padding: 0,
            display: 'flex',
            flex: 1,
            overflow: 'hidden'
          },
          contentStyle:
          /* this.props.searchQuery && this.props.searchQuery.length > 1
          ? { width: '95%', maxWidth: 1050, paddingTop: 0, transform: 'none' }
          : { width: 295, height: 55 }*/
          {
            width: '95%',
            maxWidth: 1050,
            paddingTop: 0,
            transform: 'none'
          },
          open: _this2.state.searchModalOpen,
          onRequestClose: function onRequestClose() {
            _this2.props.clearCurrentSearch(_this2.props.organization.id);

            _this2.setState({
              searchModalOpen: false
            });
          },
          repositionOnUpdate: false,
          style: {
            paddingTop: 16
          },
          title: /*#__PURE__*/React.createElement(ContentSearchModalTitle, {
            clearCurrentSearch: _this2.props.clearCurrentSearch,
            closeModal: function closeModal() {
              _this2.props.clearCurrentSearch(_this2.props.organization.id);

              _this2.setState({
                searchModalOpen: false
              });
            },
            orgId: _this2.props.organization.id,
            searching: _this2.props.searching,
            searchContent: _this2.searchContent,
            searchQuery: _this2.props.searchQuery,
            searchResults: _this2.props.searchResults,
            updateSearchQuery: _this2.props.updateSearchQuery,
            usePrevSearch: _this2.props.usePrevSearch
          })
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, !!_this2.props.searchResults && !!_this2.props.searchResults.currentResults && _this2.props.searchQuery.length > 1 ? /*#__PURE__*/React.createElement(ContentSearchResults, {
          searching: _this2.props.searching,
          clearCurrentSearch: _this2.props.clearCurrentSearch,
          results: _this2.props.searchResults ? _this2.props.searchResults.currentResults : {},
          orgId: _this2.props.organization.id,
          searchQuery: _this2.props.searchQuery
        }) : _this2.props.searchQuery.length === 0 ? /*#__PURE__*/React.createElement(EmptyState, {
          text: "Search for anything",
          subtext: /*#__PURE__*/React.createElement("span", null, "Try searching for...", ' ', /*#__PURE__*/React.createElement(Typist, {
            key: "typist_".concat(_this2.state.typistRemount),
            startDelay: 800,
            onTypingDone: function onTypingDone() {
              _this2.setState({
                typistRemount: new Date().getTime(),
                searchSuggestionIndex: function () {
                  if (_this2.state.searchSuggestionIndex + 1 >= _this2.state.searchSuggestions.length) {
                    return 0;
                  }

                  return _this2.state.searchSuggestionIndex + 1;
                }()
              });
            }
          }, /*#__PURE__*/React.createElement("span", null, _this2.state.searchSuggestions[_this2.state.searchSuggestionIndex]), /*#__PURE__*/React.createElement(Typist.Backspace, {
            count: _this2.state.searchSuggestions[_this2.state.searchSuggestionIndex].length,
            delay: 2000
          }))),
          iconName: "fa fa-search",
          iconSize: "95px",
          style: {
            marginTop: 24,
            marginBottom: 48
          }
        }) : null));
      }));
    }
  }]);

  return ContentLibrary;
}(Component)) || _class);
export default ContentLibrary;